export const DEFAULT_CAMPAIGN_NAME = 'Untitled campaign';
export const CAMPAIGN_CONTAINER_MAX_WIDTH = 350;
export const CAMPAIGN_CONTAINER_MIN_WIDTH = 290;
export const SKELETON_COUNT = 7;
